import Vue from 'vue';
import { formatTalkUser } from '@/utils/imService';
import user from './user';

const state = {
	loadStatus: 1, // 加载状态[1:未加载;2:加载中;3:加载完成;4:加载失败;]
	index_name:'',//对话列表key[session_id]
	items:[],//对话中列表
	// 最后一条消息
	unreadMessage: {
	  num: 0,
	  nickname: '未知',
	  content: '...',
	},
	index_infos:{},//当前会话用户信息
	// 聊天记录
	records: [],
	preview_text:'',//坐席预览输入中
	transformViews:{
		show:false,
		list:[]
	},//指定客服转接接收人
	chatAuthSetting:[],//当前聊天功能配置权限
	customerinfo_panels:[],//右侧客户信息缓存机制
	channle_list:[],//IM渠道
	
}
const mutations = {
	SET_LOAD_STATUS(state, resource) {
	  state.loadStatus = resource
	},
	
	// 设置对话key
	SET_INDEX_NAME:(state,session_id) => {
		state.index_name = session_id
	},
	// 设置对话中用户详情
	SET_INDEX_INFOS:(state, session_infos) => {
		state.index_infos = session_infos;
	},
	// 设置对话列表
	SET_TALK_ITEMS(state, resource) {
	  state.items = resource.items;
	},
	// 新增对话节点
	PUSH_TALK_ITEM(state, resource) {
	  state.items.push(resource)
	},
	// 更新对话节点
	UPDATE_TALK_ITEM(state, resource) {
	  for (const iterator of state.items) {
	    if (iterator.session_id === resource.session_id) {
	      Object.assign(iterator, resource)
	      break
	    }
	  }
	},
	// 移除对话节点
	REMOVE_TALK_ITEM(state, session_id) {
	  for (let i in state.items) {
	    if (state.items[i].session_id === session_id) {
	      state.items.splice(i, 1)
	      break
	    }
	  }
	  state.records = []
	  state.index_name = '';
	  state.index_infos = '';
	  Vue.prototype.$iMLocalforage.removeItem(session_id);
	},
	// 更新对话消息
	UPDATE_TALK_MESSAGE(state, resource) {
	  for (const iterator of state.items) {
	    if (iterator.session_id !== resource.session_id) {
				continue
	    }
	
	    iterator.unread_num++
		iterator.sendtime = resource.sendtime
		if(resource.sender_type == 1) {
			iterator.content = resource.content
		}
	     break
	  }
	},
	// 设置最后一条消息
	SET_TLAK_UNREAD_MESSAGE(state, resource) {
	  state.unreadMessage.num++
	  state.unreadMessage.nickname = resource.nickname
	  state.unreadMessage.content = resource.content
	},
	// 清除最后一条未读消息
	CLEAR_TLAK_UNREAD_MESSAGE(state) {
	  state.unreadMessage = {
	    num: 0,
	    nickname: '未知',
	    content: '...',
	  }
	},
	
	/*----------- 聊天记录相关------------- */
	SET_DIALOGUE(state, records) {
	  state.records = records
	},
	// 推送对话记录
	PUSH_DIALOGUE(state, record) {
	  state.records.push(record)
	},
	// 更新对话记录
	UPDATE_DIALOGUE(state, resource) {
	  for (const iterator of state.records) {
	    if (iterator.msg_id === resource.msg_id) {
	      Object.assign(iterator, resource)
	      break
	    }
	  }
	},
	// 删除对话记录[多选 单选]
	BATCH_DELETE_DIALOGUE(state, ids) {
	  ids.forEach(msg_id => {
	    let index = state.records.findIndex(item => item.msg_id == msg_id)
	    if (index >= 0) state.records.splice(index, 1)
	  })
	},
	
	
	// 更新预览信息
	UPDATE_PREVIEW_TEXT(state,obj) {
		state.preview_text = obj;
	},
	//新增转接信息
	PUSH_TRANSFORM_VIEW(state, resource) {
		let arr = state.transformViews.list;
		arr.push(resource.item);
		state.transformViews = {
			show:resource.show,
			list:arr
		}
	},
	// 更新转接信息
	UPDATE_TRANSFORM_VIEW(state, resource) {
		Object.assign(state.transformViews,resource)
	},
	// 更新聊天功能配置权限
	UPDATE_CHAT_AUTH_SETTING(state,resource) {
		state.chatAuthSetting = resource
	},
	// 添加右侧客户信息面板节点
	PUSH_CUSTOMERINFO_PANELS(state,resource) {
		state.customerinfo_panels.push(resource);
	},
	//删除右侧客户信息面板缓存节点
	DELETE_CUSTOMERINFO_PANELS(state,session_id) {
		for (let i in state.customerinfo_panels) {
		  if (state.customerinfo_panels[i].session_id === session_id) {
				state.customerinfo_panels.splice(i, 1)
				break
		  }
		}
	},
	// 清空右侧客户信息面板缓存 防止关闭页面加载多个接口
	CLEAR_CUSTOMERINFO_PANELS(state){
		state.customerinfo_panels = [];
	},
	
	/*----------- IM 前端日志存储相关 ------------- */
	UPDATE_IM_OPERATE_LOGS(state, source) {
		// const msg = `${dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')} - 操作人：${user?.state?.userInfo?.account} - 操作了： ${source.type} ${source?.content ? ' - 详细信息： ' + JSON.stringify(source?.content) : ''}`;
		// console.log(`%c${msg}`, 'color: #909399');
		Vue.prototype.$$log({
			category: "Behavior",
			sourceType: "IM",
			message:source,
		});
	},
	/*----------- IM 渠道列表 ------------- */
	SET_CHANNLE_LIST(state,source) {
		state.channle_list = source;
	},
	
	/*----------- IM indexDb聊天数据 方便对比缺数据 ------------- */
	PUSH_INDEXDB_RECORDS(state,source) {
		if(!source.msg_id) return;
		Vue.prototype.$iMLocalforage.getItem(source.session_id).then(function(value) {
		    // 当离线仓库中的值被载入时，此处代码运行
		    if(!value){
				Vue.prototype.$iMLocalforage.setItem(source.session_id,[source])
			}else {
				for(let item of value){
					if(item.msg_id != source.msg_id){
						value.push(source);
						break;
					}
				}
				Vue.prototype.$iMLocalforage.setItem(source.session_id,value)
			}
		}).catch(function(err) {
		    // 当出错时，此处代码运行
			Vue.prototype.$$log({
				category: "Behavior",
				sourceType: "IM",
				message:{
					type:'socketIndexDb存储socket消息出错',
					content:JSON.stringify(err)
				},
			});
		    Vue.prototype.$iMLocalforage.clear();
		});
	}
	
}
const actions = {
	// 加载会话列表
	load_talk_items(context) {
	  context.commit('SET_LOAD_STATUS', 2)
	Vue.prototype.$api.getImServiceDialogueLists(context.rootGetters.agentId).then(res => {
	      if (res.errcode != 0) return;
		  let results = res.data.map(item => formatTalkUser(item));
		  for(let i = 0; i < res.data.length;i++){
		  	for(let j = 0; j < context.state.items.length; j++){
		  		if(results[i].session_id == context.state.items[j].session_id){
		  			results[i].unread_num = context.state.items[j].unread_num;
		  			results[i].content = context.state.items[j].content;
					results[i].draft_text = context.state.items[j].draft_text;
		  		}
		  	}
		  }
		  
		 context.commit('SET_TALK_ITEMS', {
	        items: results,
	      })
	       context.commit('SET_LOAD_STATUS', 3)
		   // 初始化数据 防止意外关闭浏览器indexDb数据堆积
		   Vue.prototype.$iMLocalforage.keys().then(keys => {
			  keys.forEach(session_id => {
			    let index = results.findIndex(item => item.session_id == session_id)
			    if (index == -1) {
					Vue.prototype.$iMLocalforage.removeItem(session_id)
				}
			  })
		   }).catch(function(err) {
			   Vue.prototype.$$log({
					category: "Behavior",
					sourceType: "IM",
					message:{
						type:'刷新页面获取IndexDb数据keys失败',
						content:JSON.stringify(err)
					}
			   });
				Vue.prototype.$iMLocalforage.clear();
			});
	    })
	    .catch(() => {
	      context.commit('SET_LOAD_STATUS', 4)
	    })
	},
	// 加载渠道列表
	get_channel_list(context){
		Vue.prototype.$api.getIMChannelList().then(res => {
			if(res.errcode != 0) return;
			context.commit('SET_CHANNLE_LIST',res.data);
		})
	}
}
export default {
	namespaced: true,
	state,
	mutations,
	actions
}